import { render, staticRenderFns } from "./PageSecurity.vue?vue&type=template&id=52e61a68"
import script from "./PageSecurity.vue?vue&type=script&lang=js"
export * from "./PageSecurity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports